import {
  CHARGE,
  SET_ACTIVE_BARBER,
  SET_PRODUCT_BRAND_ID,
  SET_PRODUCT_CATEGORY_ID,
  SET_PRODUCT_SEARCH,
  SET_SERVICE_SEARCH,
  RESET_TAB,
  SELECT_TAB,
} from './constants';
import { IS_EMPTY } from '../order/constants';

export const setActiveBarber = id => ({
  type: SET_ACTIVE_BARBER,
  payload: id,
});

export const setProductCategory = id => ({
  type: SET_PRODUCT_CATEGORY_ID,
  payload: id,
});

export const setProductBrand = id => ({
  type: SET_PRODUCT_BRAND_ID,
  payload: id,
});

export const resetProductCategory = () => setProductCategory();
export const resetProductBrand = () => setProductBrand();

export const setProductSearch = searchString => ({
  type: SET_PRODUCT_SEARCH,
  payload: searchString,
});

export const setServiceSearch = searchString => ({
  type: SET_SERVICE_SEARCH,
  payload: searchString,
});

export const charge = () => ({ type: CHARGE });
export const isEmpty = () => ({ type: IS_EMPTY });

export const selectTab = tab => ({ type: SELECT_TAB, payload: tab });
export const resetTab = () => ({ type: RESET_TAB });
